import StickyNavigation from './navigation/StickyNavigation';

new StickyNavigation();
